// src/components/ImageCarousel/ImageCarousel.js
import React, { useState, useEffect } from 'react';
import './ImageCarousel.css';

// Import gallery images from the images directory
import img1 from '../../images/gallrey1.jpg';
import img2 from '../../images/gallery 2.jpg';
import img3 from '../../images/gallery3.jpg';
import img4 from '../../images/gallery4.jpg';
import img5 from '../../images/gallery5.jpg';
import img6 from '../../images/gallery6.jpg';

const images = [img1, img2, img3, img4, img5, img6];

const ImageCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // Automatically slide every 3.5 seconds
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel-container">
      {images.map((img, index) => (
        <div
          key={index}
          className={`carousel-slide ${index === currentIndex ? 'active' : ''}`}
        >
          <img src={img} alt={`Gallery Slide ${index + 1}`} className="carousel-image" />
        </div>
      ))}
      <div className="carousel-indicators">
        {images.map((_, index) => (
          <span 
            key={index} 
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
